import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, isRef as _isRef, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/img/128.png'


const _withScopeId = n => (_pushScopeId("data-v-361ea2e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "80",
    height: "80",
    style: {"object-fit":"contain"}
  })
], -1))
const _hoisted_4 = { class: "col-9 col-sm-9 col-md-9 col-lg-9 col-xl-9" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "row mt-3" }
const _hoisted_11 = { class: "col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10" }
const _hoisted_12 = { class: "row mt-2" }
const _hoisted_13 = { class: "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" }
const _hoisted_14 = { class: "mt-1" }
const _hoisted_15 = {
  for: "chkTogleTheme1",
  class: "switch-label"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "🌙", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "☀️", -1))
const _hoisted_18 = { class: "row mt-4" }
const _hoisted_19 = { class: "col-12" }

import ControlApp2 from '@/views/shared/controls/ControlApp2.vue';
import Dropdown from 'primevue/dropdown';
import { computed, ref } from 'vue';
import {languagesLst} from '@/i18n';
import { IonItem,IonLabel } from '@ionic/vue';
import { ISesionApp } from '@/model/ISesionApp';
import { useMainStore } from '@/store/main-store';
import { useI18n } from 'vue-i18n';
import moment from 'moment'; 
import { usePrimeVue } from "primevue/config";
import jsonLangEsDefault from '@/locales/es.json';
import jsonLangEnDefault from '@/locales/en.json'; 
import { IonButton } from '@ionic/vue';
import { inject } from "vue";
import {useServicesFactoryStore}  from '@/store/services-factory-store';
import AppSystemSettingsService from '@/services/AppSystemSettingsService';
import {IAppSystemSettings} from '@/model/IAppSystemSettings';
import {eSettingsNames,eThemesNames} from "@/model/GloblasEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppOptionsComponent',
  setup(__props) {

const dialogRef:any = inject('dialogRef');
const primevue = usePrimeVue();
const sesionApp:ISesionApp = useMainStore().getSesionApp;
const appSettingsService:AppSystemSettingsService = useServicesFactoryStore().getAppSystemSettings
const appSystemSettings:IAppSystemSettings[] = useMainStore().appSettings;
const currentLang = useI18n();
const settingTheme:IAppSystemSettings = appSettingsService.getSettingByName(eSettingsNames.theme);
const settingLanguage:IAppSystemSettings = appSettingsService.getSettingByName(eSettingsNames.language);
let userTheme = ref<string>(settingTheme? settingTheme.Value:'');
let idioma = ref<any>(languagesLst.find((x:any)=>x.id === settingLanguage.Value));
const changeTheme = ()=>
{
  const activeTheme = userTheme.value.split('_')[0].toLowerCase();    
  if (activeTheme === "light" || !activeTheme)       
    userTheme.value = eThemesNames.dark;      
  else 
    userTheme.value = '';   
}
const toggleTheme = () =>
{  
  const activeTheme = userTheme.value.split('_')[0].toLowerCase();    
  if (activeTheme === "light" || !activeTheme)
  {     
    setTheme('');//(eThemesNames.light); 
    primevue.changeTheme('lara-dark-purple','lara-light-indigo', 'site-theme-link');    

  }
  else 
  {
    setTheme(eThemesNames.dark);
    primevue.changeTheme('lara-light-indigo','lara-dark-purple', 'site-theme-link');    
  }
}
const setTheme = (theme:string) =>
{
/*https://medium.com/@dgongoragamboa/añadir-darkmode-a-un-proyecto-de-vue-3679af55b642 */
 // userTheme.value = theme;
  //document.documentElement.className = theme;
  document.documentElement.setAttribute('data-theme', theme);
  //localStorage.setItem("user-theme", theme);  
  //console.log(document.documentElement);
  //document.documentElement.className = theme;
}
const empresaEmpleado = computed(():any => 
{
  if(!sesionApp || !sesionApp.SyncData || !sesionApp.SyncData.IsEmpleado) return null;
  const id = sesionApp.SyncData.EmpresaEmpleadoId;
  const empresa = sesionApp.SyncData.getEmpresaById(id);
  return empresa;
})
const changeLanguage = ()=>
{  
  //$i18n.locale = idioma.id;
  currentLang.locale.value = idioma.value.id;
  moment.locale(idioma.value.id);  
  switch(idioma.value.id)
  {
    case 'es-mx':
      primevue.config.locale = {...jsonLangEsDefault.prime};
      break;
    case 'en-us': 
      primevue.config.locale = {...jsonLangEnDefault.prime};
      break;
  }  
}
const AplicarCambios = async ()=>
{
  changeLanguage();
  toggleTheme();
  const idLanguage =  idioma.value.id;
  const themeNew = userTheme.value;
  const settingLanguage = appSystemSettings.find((x:IAppSystemSettings)=> x.Setting === eSettingsNames.language);
  const settingTheme = appSystemSettings.find((x:IAppSystemSettings)=> x.Setting === eSettingsNames.theme);
  if(settingLanguage) settingLanguage.Value = idLanguage;
  if(settingTheme) settingTheme.Value = themeNew;
  await appSettingsService.SaveAppSettings(appSystemSettings);
  useMainStore().setAppSettings(appSystemSettings);
  useMainStore().setAppLanguage(idLanguage);
  dialogRef.value.close();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), { class: "text-short" }, {
                  default: _withCtx(() => [
                    (_unref(sesionApp) && _unref(sesionApp).User)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(sesionApp).User?.FullName()), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (empresaEmpleado.value)
              ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { class: "text-short" }, {
                      default: _withCtx(() => [
                        _createElementVNode("small", null, _toDisplayString(_unref(sesionApp).SyncData.getEmpresaName(empresaEmpleado.value)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(ControlApp2, {
          text: _ctx.$t('AppOptionsShort.changeIdioma'),
          required: false,
          "small-font": false,
          edit: true,
          tipo: 2
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Dropdown), {
              modelValue: _unref(idioma),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(idioma) ? (idioma).value = $event : idioma = $event)),
              options: _unref(languagesLst),
              optionLabel: "title",
              class: "w-100 vb-control vb-control-dropdown"
            }, {
              value: _withCtx((slotProps) => [
                (slotProps.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(`languageIco ${slotProps.value.logo}`)
                    }, [
                      _createElementVNode("span", null, _toDisplayString(slotProps.value.title), 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              option: _withCtx((slotProps) => [
                _createElementVNode("div", {
                  class: _normalizeClass(`languageIco ${slotProps.option.logo}`)
                }, [
                  _createElementVNode("span", null, _toDisplayString(slotProps.option.title), 1)
                ], 2)
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ]),
          _: 1
        }, 8, ["text"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(ControlApp2, {
          text: _ctx.$t('AppOptionsShort.changeTheme'),
          required: false,
          "small-font": false,
          edit: true,
          tipo: 2
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("input", {
                id: "chkTogleTheme1",
                type: "checkbox",
                class: "switch-checkbox",
                onChange: changeTheme
              }, null, 32),
              _createElementVNode("label", _hoisted_15, [
                _hoisted_16,
                _hoisted_17,
                _createElementVNode("div", {
                  class: _normalizeClass(["switch-toggle", { 'switch-toggle-checked': _unref(userTheme) === 'dark_Default' }])
                }, null, 2)
              ])
            ])
          ]),
          _: 1
        }, 8, ["text"])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_unref(IonButton), {
          type: "button",
          fill: "solid",
          color: 'control',
          onClick: AplicarCambios
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('globals.aceptar')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})